import styled, { css } from 'styled-components';
var withBorderStyles = css(["border-radius:8px;box-shadow:", " 0 0 0 2px;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiM;
});
export var PillIframe = styled.iframe.withConfig({
  displayName: "Iframe__PillIframe",
  componentId: "sc-di69ro-0"
})(["width:100%;height:", ";border:0;border-radius:4px;", ""], function (_ref2) {
  var height = _ref2.height;
  return height ? "".concat(height, "px") : 'auto';
}, function (_ref3) {
  var _ref3$withBorder = _ref3.withBorder,
    withBorder = _ref3$withBorder === void 0 ? false : _ref3$withBorder;
  return withBorder && withBorderStyles;
});